import type { ReactNode } from 'react';
import { cn } from './cn';

/**
 * Top app bar primitive. Two slots: `left` (brand lockup) and `right`
 * (actions row — credit pill, theme toggle, brand button, profile button).
 *
 * Headless on chrome — pass any layout. Default `tag` is `<header>` for
 * landmark semantics; supply `tag='div'` when nested inside an existing
 * landmark.
 */
export interface TopBarProps {
  left: ReactNode;
  right?: ReactNode;
  className?: string;
  tag?: 'header' | 'div';
}

export function TopBar({ left, right, className, tag = 'header' }: TopBarProps) {
  const Tag = tag;
  return (
    <Tag
      className={cn(
        'flex items-center justify-between gap-4 border-b border-border-subtle bg-bg/85 px-6 py-4 backdrop-blur-sm',
        className,
      )}
    >
      <div className="flex min-w-0 items-center gap-3">{left}</div>
      {right ? <div className="flex items-center gap-3">{right}</div> : null}
    </Tag>
  );
}
